import apiClient from "./apiClient";
import { API_ENDPOINTS } from "../config/api";

/**
 * activity-event-model D10: per-tenant opt-out of the central pseudonymous
 * usage stream. Mirrors backend platform-tenant.service TenantUsageAnalytics.
 */
export interface TenantUsageAnalytics {
  tenantId: string;
  usageAnalyticsEnabled: boolean;
}

export interface UpdateTenantUsageAnalyticsDto {
  usageAnalyticsEnabled: boolean;
}

export const usageAnalyticsService = {
  async get(tenantId: string): Promise<TenantUsageAnalytics> {
    const response = await apiClient.get<TenantUsageAnalytics>(
      `${API_ENDPOINTS.TENANTS}/${tenantId}/usage-analytics`,
    );
    return response.data;
  },

  async update(
    tenantId: string,
    dto: UpdateTenantUsageAnalyticsDto,
  ): Promise<TenantUsageAnalytics> {
    const response = await apiClient.patch<TenantUsageAnalytics>(
      `${API_ENDPOINTS.TENANTS}/${tenantId}/usage-analytics`,
      dto,
    );
    return response.data;
  },
};
